// btw-front/src/lib/keywordFilter.js
// 관리자 목록 키워드 검색 — 이미 받아온 목록을 화면에서 거른다(전체를 한 번에 받는 목록용).
// 기준은 서버 [관리 대상 딜] 검색(staleDealRoutes 의 filterByKeyword)과 같다:
// 앞뒤 공백·대소문자 무시, 최대 100자, 지정한 항목 중 하나라도 부분 일치하면 남긴다.

export const KEYWORD_MAX = 100;

// fields — 항목 이름 배열(예: ["partnerCompanyName", "customerCompany", "salesRepName"])
export function filterByKeyword(items, rawKeyword, fields) {
  const keyword =
    typeof rawKeyword === "string" ? rawKeyword.trim().slice(0, KEYWORD_MAX).toLowerCase() : "";
  if (!keyword) return items;
  return items.filter((item) =>
    fields.some((f) =>
      String(item[f] || "")
        .toLowerCase()
        .includes(keyword),
    ),
  );
}
